import { useInvoice, InvoiceItem } from "@/api/invoices"
import { useParams } from "react-router-dom"
import InvoiceEdit from "./invoice-edit"
import Loader from "@/components/layout/loader"

export default function InvoiceEditScreen() {
  const { id } = useParams()
  const { invoice } = useInvoice(id)

  if (!invoice) {
    return <Loader message="Loading invoice..." />
  }

  return (
    <InvoiceEdit
      id={id}
      invoice={{
        ...invoice,
        date: new Date(invoice.date),
        dueDate: new Date(invoice.dueDate),
        items: invoice.items.map((item: InvoiceItem) => ({
          ...item,
          quantity: item.quantity.toString(),
          unitValue: item.unitValue.toString(),
        })),
      }}
    />
  )
}
